module.exports = __webpack_public_path__ + "static/media/28.b796ee83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/28.jpg
// module id = 487
// module chunks = 0